import styles from "../../../assets/styles/componentStyles/sideNavigationPanel.module.scss"; 
import { flagShowGetStartedPage, isDelegateAccessFlagTrue, isGetStartedPageActive } from "../../../utils/constants";


const SIDE_NAVIGATION_PANEL_MAX_HEIGHT_CLASSNAMES = {
    desktop: {
        viewAIChatbotPage: {
            delegateAccess:  styles.navigationPanel284MaxHeight,
            normalAccess: styles.navigationPanel230MaxHeight
        },
        otherPage: {
            delegateAccess: {
                showGetStartedPage: {
                    active: styles.navigationPanel360MaxHeight,
                    inactive: styles.navigationPanel322MaxHeight
                },
                default: styles.navigationPanel315MaxHeight
            },
            normalAccess: {
                showGetStartedPage: {
                    active: styles.navigationPanel313MaxHeight,
                    inactive: styles.navigationPanel303MaxHeight
                },
                default: styles.navigationPanel256MaxHeight
            }
        }
    },
    mobile: {
        viewAIChatbotPage: {
            delegateAccess: styles.navigationPanel364MaxHeight,
            normalAccess: styles.navigationPanel310MaxHeight
        },
        otherPage: {
            delegateAccess: {
                showGetStartedPage: {
                    active: styles.navigationPanel415MaxHeight,
                    inactive: styles.navigationPanel405MaxHeight
                },
                default: styles.navigationPanel365MaxHeight
            },
            normalAccess: {
                showGetStartedPage: {
                    active: styles.navigationPanel390MaxHeight,
                    inactive: styles.navigationPanel380MaxHeight
                },
                default: styles.navigationPanel340MaxHeight
            }
        }
    }
}

export const getSideNavigationPanelMaxHeightClassName = (pathname, userDetail, view) => {
    const viewConfig = SIDE_NAVIGATION_PANEL_MAX_HEIGHT_CLASSNAMES[view];
    if (!viewConfig) return "";

    const isViewAIChatbotPage = pathname.includes("/chatbot/viewchatbot");
    const isDelegateAccess = isDelegateAccessFlagTrue(userDetail);
    const accessKey = isDelegateAccess ? "delegateAccess" : "normalAccess";

    // View AI Chatbot Page
    if (isViewAIChatbotPage) {
        return viewConfig.viewAIChatbotPage[accessKey];
    }

    // Other Pages
    const otherPageConfig = viewConfig.otherPage[accessKey];

    if (flagShowGetStartedPage(userDetail)) {
        const getStartedPageActivityKey = isGetStartedPageActive() ? "active" : "inactive";
        return otherPageConfig.showGetStartedPage[getStartedPageActivityKey];
    }

    return otherPageConfig.default;
}

// Ctrl/Cmd/Shift + click (or middle click) on a menu link: let the browser open it in a new tab/window
// instead of navigating inside the app
export const isNewTabClick = (event) => event.ctrlKey || event.metaKey || event.shiftKey || event.button === 1;
